var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "dashboard-module-small d-flex justify-content-between align-items-top"
    },
    [
      _c(
        "div",
        { staticClass: " d-flex justify-content-center align-items-center " },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "dashboard-module-small--icon",
                style: "background-color:" + _vm.icon.color
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dashboard-module--counter number_circle" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.settings.sale_count) +
                        "\n                "
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("h6", {
              staticClass: "dashboard-module-small--title",
              domProps: { innerHTML: _vm._s(_vm.settings.title) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard-module-small--value" }, [
              _vm._v(_vm._s(_vm.currency) + _vm._s(_vm.settings.sale_total))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("actions-menu-module", {
        attrs: {
          download: {
            name: _vm.settings.file_name + "." + _vm.exportData.type,
            type: _vm.exportData.type,
            fields: _vm.exportData.json_fields,
            data: _vm.exportData.json_data
          }
        },
        on: { click_events: _vm.actionEventHandler }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("shopping_cart")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cdb0dae4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdb0dae4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/modules/SalesModuleSmall.vue
// module id = 669
// module chunks = 0